// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MessageGroup_message__block__WrkLT {
  padding-left: 16px;
  padding-bottom: 16px;
  display: flex;
  justify-content: flex-start;
  min-width: 0;
}
.MessageGroup_message__blockOwn__ghNfM {
  padding-left: 0px;
  padding-right: 16px;
  justify-content: flex-end;
}
.MessageGroup_message__main__XvRaY {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  flex-grow: 1;
  min-width: 0;
}
.MessageGroup_message__mainOwn__TIiuW {
  align-items: flex-end;
}
.MessageGroup_message__name__dpH-U {
  text-decoration: none;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #272A36;
  margin-bottom: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  transition: 0.3s color;
}
.MessageGroup_message__name__dpH-U:hover {
  color: #2c5bcc;
}
.MessageGroup_message__prepend__Yb2c1 {
  flex-shrink: 0;
  padding-right: 8px;
}

.MessageGroup_content__bAUb2 {
  -webkit-user-select: text;
          user-select: text;
  background: #F7F7F7;
  display: inline-flex;
  flex-direction: column;
  font-size: 14px;
  max-width: 60%;
  align-items: stretch;
}
.MessageGroup_content__prepend__9eDjX {
  padding: 8px 8px 0 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
.MessageGroup_content__wrapper__z2t-C {
  background: white;
  -webkit-user-select: none;
          user-select: none;
  width: 100%;
  display: flex;
  justify-content: flex-start;
}
.MessageGroup_content__wrapper__z2t-C:not(:last-child) {
  padding-bottom: 4px;
}
.MessageGroup_content__wrapperOwn__ztn2e {
  justify-content: flex-end;
}
.MessageGroup_content__wrapperHighlighted__thxjo {
  background: #FAFBFC;
  transition: 0.3s background;
}
.MessageGroup_contentOwn__cNQLV {
  background: linear-gradient(0deg, #E8F2FD, #E8F2FD), #4778EE;
}
.MessageGroup_contentFirst__-xKWD {
  border-radius: 8px 8px 8px 0px;
}
.MessageGroup_contentMiddle__in36j {
  border-radius: 0px 8px 8px 0px;
}
.MessageGroup_contentLast__OnhFI {
  border-radius: 0px 8px 8px 8px;
}
.MessageGroup_contentOwnFirst__BVAm9 {
  border-radius: 8px 8px 0px 8px;
}
.MessageGroup_contentOwnMiddle__Fcr9c {
  border-radius: 8px 0px 0px 8px;
}
.MessageGroup_contentOwnLast__VyXMB {
  border-radius: 8px 0px 8px 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/chats/MessageGroup/MessageGroup.module.scss"],"names":[],"mappings":"AAWE;EAEE,kBAAA;EACA,oBAAA;EACA,aAAA;EACA,2BAAA;EACA,YAAA;AAXJ;AAaI;EACE,iBAAA;EACA,mBAAA;EAEA,yBAAA;AAZN;AAgBE;EACE,oBAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;AAdJ;AAiBI;EACE,qBAAA;AAfN;AAmBE;EACE,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EAEA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EAEA,sBAAA;AAnBJ;AAqBI;EACE,cAAA;AAnBN;AAuBE;EACE,cAAA;EACA,kBAAA;AArBJ;;AAyBA;EACE,yBAAA;UAAA,iBAAA;EACA,mBAAA;EAEA,oBAAA;EACA,sBAAA;EACA,eAAA;EACA,cAzEU;EA0EV,oBAAA;AAvBF;AA0BE;EACE,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;AAxBJ;AA2BE;EACE,iBAAA;EAEA,yBAAA;UAAA,iBAAA;EAEA,WAAA;EACA,aAAA;EACA,2BAAA;AA3BJ;AA6BI;EACE,mBAAA;AA3BN;AA8BI;EACE,yBAAA;AA5BN;AA+BI;EACE,mBAAA;EACA,2BAAA;AA7BN;AAiCE;EACE,4DAAA;AA/BJ;AAmCE;EACE,8BA/GkB;AA8EtB;AAoCE;EACE,8BAlHmB;AAgFvB;AAqCE;EACE,8BArHiB;AAkFrB;AAsCE;EACE,8BAvHsB;AAmF1B;AAuCE;EACE,8BA1HuB;AAqF3B;AAwCE;EACE,8BA7HqB;AAuFzB","sourcesContent":["$max-width: 60%;\n\n$first-border-radius: 8px 8px 8px 0px;\n$middle-border-radius: 0px 8px 8px 0px;\n$last-border-radius: 0px 8px 8px 8px;\n\n$own-first-border-radius: 8px 8px 0px 8px;\n$own-middle-border-radius: 8px 0px 0px 8px;\n$own-last-border-radius: 8px 0px 8px 8px;\n\n.message {\n  &__block {\n    //padding: 0px 16px 0;\n    padding-left: 16px;\n    padding-bottom: 16px;\n    display: flex;\n    justify-content: flex-start;\n    min-width: 0;\n\n    &Own {\n      padding-left: 0px;\n      padding-right: 16px;\n\n      justify-content: flex-end;\n    }\n  }\n\n  &__main {\n    display: inline-flex;\n    flex-direction: column;\n    align-items: flex-start;\n    flex-grow: 1;\n    min-width: 0;\n    //width: 100%;\n\n    &Own {\n      align-items: flex-end;\n    }\n  }\n\n  &__name {\n    text-decoration: none;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 14px;\n    color: #272A36;\n    margin-bottom: 2px;\n\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 100%;\n\n    transition: 0.3s color;\n\n    &:hover {\n      color: #2c5bcc;\n    }\n  }\n\n  &__prepend {\n    flex-shrink: 0;\n    padding-right: 8px;\n  }\n}\n\n.content {\n  user-select: text;\n  background: #F7F7F7;\n  //border-radius: 0px 8px 8px 8px;\n  display: inline-flex;\n  flex-direction: column;\n  font-size: 14px;\n  max-width: $max-width;\n  align-items: stretch;\n\n\n  &__prepend {\n    padding: 8px 8px 0 8px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 100%;\n  }\n\n  &__wrapper {\n    background: white;\n\n    user-select: none;\n    //padding: 0 16px;\n    width: 100%;\n    display: flex;\n    justify-content: flex-start;\n\n    &:not(:last-child) {\n      padding-bottom: 4px;\n    }\n\n    &Own {\n      justify-content: flex-end;\n    }\n\n    &Highlighted {\n      background: #FAFBFC;\n      transition: 0.3s background;\n    }\n  }\n\n  &Own {\n    background: linear-gradient(0deg, #E8F2FD, #E8F2FD), #4778EE;\n    //border-radius: 8px 8px 0px 8px;\n  }\n\n  &First {\n    border-radius: $first-border-radius;\n  }\n\n  &Middle {\n    border-radius: $middle-border-radius;\n  }\n\n  &Last {\n    border-radius: $last-border-radius;\n  }\n\n  &OwnFirst {\n    border-radius: $own-first-border-radius;\n  }\n\n  &OwnMiddle {\n    border-radius: $own-middle-border-radius;\n  }\n\n  &OwnLast {\n    border-radius: $own-last-border-radius;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"message__block": `MessageGroup_message__block__WrkLT`,
	"message__blockOwn": `MessageGroup_message__blockOwn__ghNfM`,
	"message__main": `MessageGroup_message__main__XvRaY`,
	"message__mainOwn": `MessageGroup_message__mainOwn__TIiuW`,
	"message__name": `MessageGroup_message__name__dpH-U`,
	"message__prepend": `MessageGroup_message__prepend__Yb2c1`,
	"content": `MessageGroup_content__bAUb2`,
	"content__prepend": `MessageGroup_content__prepend__9eDjX`,
	"content__wrapper": `MessageGroup_content__wrapper__z2t-C`,
	"content__wrapperOwn": `MessageGroup_content__wrapperOwn__ztn2e`,
	"content__wrapperHighlighted": `MessageGroup_content__wrapperHighlighted__thxjo`,
	"contentOwn": `MessageGroup_contentOwn__cNQLV`,
	"contentFirst": `MessageGroup_contentFirst__-xKWD`,
	"contentMiddle": `MessageGroup_contentMiddle__in36j`,
	"contentLast": `MessageGroup_contentLast__OnhFI`,
	"contentOwnFirst": `MessageGroup_contentOwnFirst__BVAm9`,
	"contentOwnMiddle": `MessageGroup_contentOwnMiddle__Fcr9c`,
	"contentOwnLast": `MessageGroup_contentOwnLast__VyXMB`
};
export default ___CSS_LOADER_EXPORT___;
